import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, switchMap } from 'rxjs';
import { warehousesActions } from '../actions/warehouses.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class WarehousesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getWarehouses$ = createEffect(() => {
        return this.actions.pipe(
            ofType(warehousesActions.getWarehouses),
            switchMap(({ value }) => {
                return this.httpService.getWarehouses(value).pipe(
                    map((payload) => warehousesActions.getWarehousesSuccess({ payload })),
                    catchError((response: HttpErrorResponse) => of(warehousesActions.getWarehousesError({ code: response.status }))),
                );
            }),
        );
    });
}
